module.exports = __webpack_public_path__ + "static/media/timed-bonus-chest-close.6ca97cf9.png";